import CalendarConfigurationState from './schema/CalendarConfigurationState';
import { createStore } from 'satcheljs';

export default createStore<CalendarConfigurationState>('calendarConfiguration', {
    calendarConfiguration: null,
    txpSettings: null,
})();
